import {Image} from '@/_application/core/components/ui/image';
import {Eye} from '@/_application/icons/eye-icon';
import {productPlaceholder} from '@/lib/placeholders';
import {Customer, Post} from '__generated__/__types__';
import useEventTrackingService from '@/_application/modules/tracking/service/event-tracking.service';
import {TrackingTargetProviderEnum} from '@kidslabs/mario-client-event-tracking';
import {useSession} from 'next-auth/react';
import {generateCustomerInput} from '@/_application/modules/tracking/cdp/utils/input';

interface IUsefulInformationItemProps {
    readonly usefulInformation: Post;
}

function UsefulInformationItem({usefulInformation}: Readonly<IUsefulInformationItemProps>) {
    const {post_url, thumb_img, post_title, author, views_count, id, post_name} = usefulInformation;
    const {trackViewContentEvent: trackCdp} = useEventTrackingService(TrackingTargetProviderEnum.CDP);
    const {data: session} = useSession();
    const customer = session?.user as Customer;

    const handleReadPost = () => {
        trackCdp({
            viewType: 'ViewArticle',
            contents: [
                {
                    id: `${id ?? 'no-id-content'}`,
                    quantity: 1,
                },
            ],
            content_name: post_name as string,
            article_data: {
                title: post_title as string,
                page_url: post_url as string,
            },
            customer: generateCustomerInput(customer),
        }).then(() => {});
    };

    if (!post_url) return <></>;
    return (
        <a href={post_url} onClick={handleReadPost}>
            <div
                className={
                    'mx-auto h-[202px] w-[223px] max-w-md overflow-hidden rounded-[20px] bg-white shadow-md md:h-[214px] md:w-[242px]'
                }>
                <div className="relative h-[136px] w-full">
                    <Image
                        src={thumb_img ?? productPlaceholder}
                        fill
                        sizes={'100%'}
                        alt={post_title ?? 'Post'}
                        className="h-full w-full rounded-b-[20px] object-cover object-center"
                    />
                </div>

                <div className="px-[18px] pb-2.5 pt-2">
                    <h3 className="line-clamp-2 h-8 text-xs font-bold text-KPZ_Orange transition-opacity hover:opacity-80 md:mb-2.5 md:h-9 md:text-sm">
                        {post_title}
                    </h3>

                    <div className="flex h-6 flex-wrap items-center justify-between gap-1 text-primary md:h-4">
                        <p className="text-[10px] md:text-xs">
                            Bởi <span className="font-bold">{author ?? 'Kidsplaza'}</span>
                        </p>

                        <p className="flex items-center gap-1">
                            <Eye className="h-4 w-4 flex-1" />
                            <span className="text-[10px] font-bold md:text-xs">{views_count ?? 0}</span>
                        </p>
                    </div>
                </div>
            </div>
        </a>
    );
}

export default UsefulInformationItem;
